import classNames from 'classnames';
import ColorOption from './components/ColorOption';

import './ColorPicker.scss';

const ColorPicker = ({ className = null, colors, selectedColor, onChange }) => {
	return (
		<div className={classNames('color-picker', className)}>
			{Object.entries(colors).map(([key, value]) => (
				<ColorOption
					key={key}
					gradients={value?.backgroundGradients}
					selected={key === selectedColor}
					onClick={() => onChange(key)}
				/>
			))}
		</div>
	);
};

export default ColorPicker;
